// components/sign-in-button.tsx
"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";

interface SignInButtonProps {
  size?: "sm" | "default" | "lg";
}

export function SignInButton({ 
  size = "sm" 
}: SignInButtonProps) {
  const t = useTranslations("header.nav");
  const pathname = usePathname();
  const locale = pathname?.split("/")[1] || "zh";

  return (
    <div className="flex items-center gap-2 ">
      <Button
        variant="outline"
        size={size}
        className="border-primary text-primary hover:bg-primary/10 hover:text-primary font-bold"
        asChild
      >
        <Link href={`/${locale}/login`}>{t("signIn")}</Link>
      </Button>

      <Button
        variant="default"
        size={size}
        asChild
      >
        <Link href={`/${locale}/register`}>{t("register")}</Link>
      </Button>
    </div>
  );
}

export default SignInButton;